import React from 'react';
import { ReceivingManualListTemplate } from 'themes/modules/receiving/pages';
import { ReceivingManualListViewStore } from 'modules/receiving/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReceivingManualListViewStore(rootStore), 'receivingManualListViewStore')
class ReceivingManualList extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<ReceivingManualListTemplate
				{...this.props}
				change={this.props.receivingManualListViewStore.change}
				actions={this.props.receivingManualListViewStore}
				viewStore={this.props.receivingManualListViewStore}
			/>
		);
	}
}

export default ReceivingManualList;



// WEBPACK FOOTER //
// ./src/modules/receiving/pages/manual/ReceivingManualList.jsx